import React, { useEffect, useState } from "react";
import { FiPackage } from "react-icons/fi";
import { TbGridPattern } from "react-icons/tb";
import { CiUser } from "react-icons/ci";
import styles from "../styles/AdminStats.module.scss";
import api from "../../../utils/api";
import OrdersSection from "../components/OrdersSection";
import PatternsSection from "../components/PatternsSection";
import UsersSection from "../components/UsersSection";
import { Heading3 } from "../../../components/value-cssmodules/TextComponent";
import { OrderStats, PatternStats, UserStats } from "../types/adminStats.type";
import Spinner from "../../../components/Spinner";
import { useIntl } from "react-intl";


function Section({
  title,
  children,
}: {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <section className={styles.section}>
      <h3 className={`ui header ${styles.sectionHeader}`}>
        <Heading3 className="content">{title}</Heading3>
      </h3>
      {children}
    </section>
  );
}

export default function AdminStats(): React.ReactElement {
  const [orderStats,   setOrderStats]   = useState<OrderStats | null>(null);
  const [patternStats, setPatternStats] = useState<PatternStats | null>(null);
  const [userStats,    setUserStats]    = useState<UserStats | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      try {
        const [orders, patterns, users] = await Promise.all([
          api.get("/admin/stats/orders"),
          api.get("/admin/stats/patterns"),
          api.get("/admin/stats/users"),
        ]);
        setLoading(false)
        setOrderStats(orders.data);
        setPatternStats(patterns.data);
        setUserStats(users.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false)
      }
    };
    fetchAll();
  }, []);

  const intl = useIntl();

  if (loading) 
    return <Spinner />

  return (
    <div className={`ui container ${styles.page}`}>

      {/* ── Orders ── */}
      <Section title={intl.formatMessage({ id: "admin.stats.sectionOrders", defaultMessage: "Orders" })} icon={<FiPackage />}>
        <OrdersSection data={orderStats} />
      </Section>

      <div className={`ui divider ${styles.divider}`} />

      {/* ── Patterns ── */}
      <Section title={intl.formatMessage({ id: "admin.stats.sectionPatterns", defaultMessage: "Patterns" })} icon={<TbGridPattern />}>
        <PatternsSection data={patternStats} />
      </Section>

      <div className={`ui divider ${styles.divider}`} />

      {/* ── Users ── */}
      <Section title={intl.formatMessage({ id: "admin.stats.sectionUsers", defaultMessage: "Users" })} icon={<CiUser />}>
        <UsersSection data={userStats} />
      </Section>

    </div>
  );
}